export const getResultsStyles = theme => {
  const cell = {
    textAlign: 'center',
    color: '#67666A',
    fontSize: '14px',
    fontFamily: 'Open Sans',
    borderRadius: '0px',
    minHeight: '60px',
    display: 'flex',
    placeItems: 'center',
    justifyContent: 'center',
    border: 'solid 1px #E5E5E5',
    [theme.breakpoints.up(1500)]: {
      fontSize: '16px',
    },
  };

  const grayCell = {
    ...cell,
    backgroundColor: '#EAEAEA',
    fontSize: '14px',
    fontWeight: 700,
  };

  const cellDay = {
    fontWeight: 400,
    flexDirection: 'column',
  };

  const cellMonths = {
    minHeight: 'initial',
    border: 'none',
  };

  const priceCell = {
    ...cell,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
    },
  };

  const threeDaysMatrixContainer = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#E5E5E5',
    marginBottom: '1vh',
    borderRadius: '8px',
    border: 'solid 4px #E5E5E5',
    [theme.breakpoints.down('sm')]: {
      border: 'none',
    },
  };

  return {
    cell,
    grayCell,
    cellDay,
    cellMonths,
    priceCell,
    threeDaysMatrixContainer,
    noShadow: { ...threeDaysMatrixContainer },
    leftShadow: {
      ...threeDaysMatrixContainer,
      boxShadow: '10px 0px 5px #67666A',
    },
    rightShadow: {
      ...threeDaysMatrixContainer,
      boxShadow: '-10px 0px 5px #67666A',
    },
    priceCellToday: {
      ...priceCell,
      backgroundColor: '#67666A',
      color: '#FFFFFF',
      cursor: 'default',
    },
    priceCellCheapest: {
      ...priceCell,
      color: theme.primary,
      backgroundColor: theme.primary,
    },
    priceCellNotAvailable: {
      ...priceCell,
      '&:hover': { backgroundColor: '#FFEAEA' },
      cursor: 'default',
    },
    tabGridItem: {
      position: 'relative',
      backgroundColor: '#FFFFFF',
      cursor: 'pointer',
      '&:hover': { boxShadow: '0px 3px 0px #00000033', zIndex: 1 },
    },
    borderGrayLeftCell: {
      ...grayCell,
      borderRadius: '15px 0 0 0',
      display: 'flex',
      fontSize: '16px',
    },
    grayGoRTCellMonths: { ...grayCell, ...cellMonths },
    grayCellDay: { ...grayCell, ...cellDay },
    grayCellMonths: { ...grayCell, ...cellMonths },
    grayCellDayMob: {
      ...grayCell,
      ...cellDay,
      [theme.breakpoints.down('sm')]: { borderRadius: '0 15px 0 0' },
    },
    checkImage: { position: 'relative', top: '4px', right: '4px' },
    cellCheckImage: {
      position: 'relative',
      right: '-2px',
      [theme.breakpoints.down('sm')]: { right: '-6px' },
    },
    bestPriceText: {
      fontFamily: 'Open Sans',
      fontWeight: 600,
      fontSize: '16px',
      padding: '8px',
      color: '#000000',
    },
    notFound: {
      backgroundColor: '#FFFFFF',
      width: '100%',
      padding: { xs: '8px 8px 0px 10px', sm: '1rem' },
      justifyContent: 'center',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },
    circleRoot: { position: 'relative' },
    circleTop: { position: 'absolute', left: 0 },
    updateButton: {
      border: `2px solid ${theme.primary}`,
      boxShadow: '0px 4px 6px #00000026',
      borderRadius: '8px',
      textDecoration: 'none',
      height: '50px',
      backgroundColor: theme.primary,
      width: '100%',
      maxWidth: 'max-content',
      '&:hover': { backgroundColor: theme.primary, color: theme.text1 },
      padding: '13px 30px',
      marginTop: '1rem',
      lineHeight: 'inherit',
    },
    bottonCellSelect: { backgroundColor: '#636466' },
    bottonCell: { backgroundColor: '#E5E5E5' },
    filtersAirlines: {
      [theme.breakpoints.down('sm')]: { padding: '1rem 0px' },
    },
    notAvailable: {
      fontFamily: 'Open Sans',
      fontSize: { xs: '16px', sm: '18px' },
      color: '#000000',
      fontWeight: 700,
      backgroundColor: '#FFFFFF',
    },
    threeDaysContainer: {
      [theme.breakpoints.down('sm')]: {
        padding: '0px 8px',
      },
      border: '4px solid #E5E5E5',
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      backgroundColor: '#FFFFFF',
      padding: '2rem',
    },
  };
};
